import { useEffect, useState } from "react";
import {
  Category,
  Shop,
  OrderLargeClassification,
  Supplier,
  TyreOptions,
  WheelOptions,
  StorehouseSupplierOptionsWithBlank,
  OrderStatus,
  OrderReceiptStatus,
  HasRepresentativeCd,
  ProductSearchInfo,
  TyreWheelRepresentativeSearchWithBlank,
  ProductCdSearchParam,
  GeneralRepresentativeSearchWithBlank,
} from "../types";
import searchProductCdApi from "../api/searchProductCdApi";

/**
 * 商品コード検索hooks
 * @param clientCd 得意先コード（得意先の商品コードを調べる時は、得意先に設定されている商品コードのみ持ってくるため）
 * @returns JSX.Element
 */
export default function useProductCdSearch(clientCd?: string) {
  const [isLoading, setIsLoading] = useState(false);
  const [generalRepresentativeCd, setGeneralRepresentativeCd] =
    useState<GeneralRepresentativeSearchWithBlank>("");
  const [tyreWheelRepresentativeCd, setTyreWheelRepresentativeCd] =
    useState<TyreWheelRepresentativeSearchWithBlank>("");
  const [classification, setClassification] = useState("");
  const [supplier, setSupplier] = useState("");
  const [productName, setProductName] = useState("");
  const [brand, setBrand] = useState("");
  const [tyreWidth, setTyreWidth] = useState<number | undefined>(undefined);
  const [tyreRatio, setTyreRatio] = useState<number | undefined>(undefined);
  const [tyreRimDiam, setTyreRimDiam] = useState<number | undefined>(undefined);
  const [wheelWidth, setWheelWidth] = useState<number | undefined>(undefined);
  const [wheelPcd, setWheelPcd] = useState<number | undefined>(undefined);
  const [wheelHole, setWheelHole] = useState<number | undefined>(undefined);
  const [wheelRimDiam, setWheelRimDiam] = useState<number | undefined>(undefined);
  const [productInfoList, setProductInfoList] = useState<ProductSearchInfo[]>([]);
  const [subclass, setSubclass] = useState("");

  const get = async (params: ProductCdSearchParam) => {
    setIsLoading(true);
    try {
      const data = await searchProductCdApi(params, clientCd ?? undefined);
      setProductInfoList(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return [
    {
      productName,
      brand,
      tyreWidth,
      tyreRatio,
      tyreRimDiam,
      wheelWidth,
      wheelPcd,
      wheelHole,
      wheelRimDiam,
      classification,
      supplier,
      tyreWheelRepresentativeCd,
      generalRepresentativeCd,
      productInfoList,
      subclass,
    },
    {
      setProductName,
      setBrand,
      setTyreWidth,
      setTyreRatio,
      setTyreRimDiam,
      setWheelWidth,
      setWheelPcd,
      setWheelHole,
      setWheelRimDiam,
      setClassification,
      setSupplier,
      setTyreWheelRepresentativeCd,
      setGeneralRepresentativeCd,
      setProductInfoList,
      setSubclass,
      get,
    },
    { isLoading },
  ] as const;
}
